import { useEffect } from 'react';

import setDeviceIdCookie from '@/utils/SetDeviceIdCookie';

export default function SetDeviceIdCookieComponent() {
    useEffect(() => {
        return setDeviceIdCookie();
    }, []);

    return <></>;
}
